
const FingerPrint = "BD"
const { Color } = Cesium;

//注册动态墙体材质-纵向
import source_DynamicWall_Type from './DynamicWallMaterial.js'
import DynamicWallMaterialProperty from "../MaterialProperty/DynamicWallMaterialProperty.js"

function registerDynamicWallMaterial(Material) {
    Material.DefaultImageDynamicWallType = "data/img/effects/polylineTrailLinkMaterial.png";
    Material.DynamicWallType = FingerPrint + "DynamicWallType";
    Material._materialCache.addMaterial(Material.DynamicWallType, {
        fabric: {
            type: Material.DynamicWallType,
            uniforms: {
                time: 0,
                color: new Color(0.0, 0.0, 1.0, 0.5),
                image: Material.DefaultImageDynamicWallType,
            },
            source: source_DynamicWall_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.DynamicWallMaterialProperty = DynamicWallMaterialProperty;
}

//注册横向墙体
import source_StandardWallMaterial_Type from './StandardWallMaterial'
import StandardWallMaterialProperty from '../MaterialProperty/StandardWallMaterialProperty'
function registerStandardWallMaterial(Material) {
    Material.StandardWallMaterialType = FingerPrint + "StandardWallMaterialType";
    Material.DefaultImageStandardWallMaterialType = "data/img/effects/arrow-2left.png";
    Material._materialCache.addMaterial(Material.StandardWallMaterialType, {
        fabric: {
            type: Material.StandardWallMaterialType,
            uniforms: {
                color: new Cesium.Color(0.2, 1, 0, 1),
                image: Material.DefaultImageStandardWallMaterialType,
                time: 0,
                count: 1
            },
            source: source_StandardWallMaterial_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.StandardWallMaterialProperty = StandardWallMaterialProperty;
}



//注册流动线材质
import source_PolylineTrail_Type from './PolylineTrailLinkMaterial'
import PolylineTrailLinkMaterialProperty from "../MaterialProperty/PolylineTrailLinkMaterialProperty"

function registerPolylineTrailLinkMaterial(Material) {
    Material.DefaultImagePolylineTrailType = "data/img/effects/line-gradual.png";
    //Material.DefaultImagePolylineTrailType = "data/img/effects/line-vertebral-blue.png";
    Material.PolylineTrailType = FingerPrint + "PolylineTrailType";
    Material._materialCache.addMaterial(Material.PolylineTrailType, {
        fabric: {
            type: Material.PolylineTrailType,
            uniforms: {
                color: new Cesium.Color(0.0, 0.0, 1.0, 0.5),
                image: Material.DefaultImagePolylineTrailType,
                time: 0
            },
            source: source_PolylineTrail_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.PolylineTrailLinkMaterialProperty = PolylineTrailLinkMaterialProperty;
}

//注册扩散圆材质
import source_DiffusionCircle_Type from './DiffusionCircleMaterial'
import DiffusionCircleMaterialProperty from '../MaterialProperty/DiffusionCircleMaterialProperty'

function registerDiffusionCircleMaterial(Material) {
    Material.DiffusionCircleType = FingerPrint + "DiffusionCircle";
    Material._materialCache.addMaterial(Material.DiffusionCircleType, {
        fabric: {
            type: Material.DiffusionCircleType,
            uniforms: {
                color: new Cesium.Color(0.0, 0.0, 1.0, 0.5),
                time: 0
            },
            source: source_DiffusionCircle_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.DiffusionCircleMaterialProperty = DiffusionCircleMaterialProperty;
}


//注册扩散圆材质-A
import source_DynamicCircleA_Type from './DynamicCircleAMaterial'
import DynamicCircleAMaterialProperty from '../MaterialProperty/DynamicCircleAMaterialProperty'

function registerDynamicCircleAMaterial(Material) {
    Material.DynamicCircleAType = FingerPrint + "DynamicCircleA";
    Material._materialCache.addMaterial(Material.DynamicCircleAType, {
        fabric: {
            type: Material.DynamicCircleAType,
            uniforms: {
                color: new Cesium.Color(0.0, 0.0, 1.0, 0.5),
                time: 10
            },
            source: source_DynamicCircleA_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.DynamicCircleAMaterialProperty = DynamicCircleAMaterialProperty;
}

//注册扩散圆材质-B
import source_DynamicCircleB_Type from './DynamicCircleBMaterial'
import DynamicCircleBMaterialProperty from '../MaterialProperty/DynamicCircleBMaterialProperty'

function registerDynamicCircleBMaterial(Material) {
    Material.DynamicCircleBType = FingerPrint + "DynamicCircleB";
    Material._materialCache.addMaterial(Material.DynamicCircleBType, {
        fabric: {
            type: Material.DynamicCircleBType,
            uniforms: {
                color: new Cesium.Color(0.0, 0.0, 1.0, 0.5),
                time: 10,
                count: 2,
                gradient: 0.2
            },
            source: source_DynamicCircleB_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.DynamicCircleBMaterialProperty = DynamicCircleBMaterialProperty;
}

//注册雷达扫描材质材质
import source_RadarRadiationWave_Type from './RadarRadiationWaveMaterial'
import RadarRadiationWaveMaterialProperty from '../MaterialProperty/RadarRadiationWaveMaterialProperty'

function registerRadarRadiationWaveMaterial(Material) {
    Material.RadarRadiationWaveType = FingerPrint + "RadarRadiationWaveType";
    Material._materialCache.addMaterial(Material.RadarRadiationWaveType, {
        fabric: {
            type: Material.RadarRadiationWaveType,
            uniforms: {
                color: new Cesium.Color(0.2, 1, 0, 1),
                repeat: 1,
                offset: 0,
                thickness: 0.8,
                time: -20
            },
            source: source_RadarRadiationWave_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.RadarRadiationWaveMaterialProperty = RadarRadiationWaveMaterialProperty;
}

//动态水材质
import source_DynamicWaterMaterial_Type from './DynamicWaterMaterial'
import DynamicWaterMaterialProperty from '../MaterialProperty/DynamicWaterMaterialProperty'
function registerDynamicWaterMaterial(Material) {
    Material.DynamicWaterMaterialType = FingerPrint + "DynamicWaterMaterialType";
    Material._materialCache.addMaterial(Material.DynamicWaterMaterialType, {
        fabric: {
            type: Material.DynamicWaterMaterialType,
            uniforms: {
                color: new Cesium.Color(0.2, 1, 0, 1),
            },
            source: source_DynamicWaterMaterial_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.DynamicWaterMaterialProperty = DynamicWaterMaterialProperty;
}

//电光弧圈
import source_ElectricArcMaterial_Type from './ElectricArcMaterial'
import ElectricArcMaterialProperty from '../MaterialProperty/ElectricArcMaterialProperty'
function registerElectricArcMaterialMaterial(Material) {
    Material.ElectricArcMaterialType = FingerPrint + "ElectricArcMaterialType";
    Material._materialCache.addMaterial(Material.ElectricArcMaterialType, {
        fabric: {
            type: Material.ElectricArcMaterialType,
            uniforms: {
                color: new Cesium.Color(0, 1, 0, 1),
                speed: 1,
            },
            source: source_ElectricArcMaterial_Type,
        },
        translucent: function (material) {
            return true;
        }
    });
    Cesium.ElectricArcMaterialProperty = ElectricArcMaterialProperty;
}

//流动线
import source_LineFlowMaterial_Type from './LineFlowMaterial.js'
import LineFlowMaterialProperty from '../MaterialProperty/LineFlowMaterialProperty'
function registerLineFlowMaterial(Material) {
    Material.LineFlowMaterialType = FingerPrint + "LineFlowMaterialType";
    Material.DefaultImageStandardWallMaterialType = "data/img/effects/arrow-2left.png";
    var color = new Cesium.Color(1, 0, 0, 1.0);
    var image = Material.DefaultImageStandardWallMaterialType; //必须是png
    var repeat = {
        x: 10,
        y: 1
    };
    var axisY = false;
    var speed = 1; //速度建议1-10
    Cesium.Material._materialCache.addMaterial(Material.LineFlowMaterialType, {
        fabric: {
            type: Material.LineFlowMaterialType,
            uniforms: {
                color: color,
                image: image,
                repeat: repeat,
                axisY: axisY,
                speed: speed
            },
            source: source_LineFlowMaterial_Type
        },
        translucent: function translucent(material) {
            return true;
        }
    })
    Cesium.LineFlowMaterialProperty = LineFlowMaterialProperty;
}


//OD线
import source_SatelliteMaterial_Type from './SatelliteMaterial.js'
import SatelliteMaterialProperty from '../MaterialProperty/SatelliteMaterialProperty'
function registerSatelliteMaterial(Material) {
    Material.SatelliteMaterialType = FingerPrint + "SatelliteMaterialType";
    var color = new Cesium.Color(1, 0, 0, 1.0);
    Cesium.Material._materialCache.addMaterial(Material.SatelliteMaterialType, {
        fabric: {
            type: Material.SatelliteMaterialType,
            uniforms: {
                color: color,
                speed: 30.0,
                gradient: 0.2,
                count: 15,
                backgroundColor: color
            },
            source: source_SatelliteMaterial_Type
        },
        translucent: function translucent(material) {
            return true;
        }
    })
    Cesium.SatelliteMaterialProperty = SatelliteMaterialProperty;
}



//OD线
import PolyGradientMaterial_Type from './mars/PolyGradientMaterial'
import PolyGradientMaterialProperty from '../MaterialProperty/mars/PolyGradientMaterialProperty'
function registerPolyGradientMaterial(Material) {
    Material.PolyGradientMaterial_Type = FingerPrint + "PolyGradientMaterial_Type";
    var color = new Cesium.Color(1, 0, 0, 1.0);
    var center = new Cesium.Cartesian2(0.5, 0.5);
    Cesium.Material._materialCache.addMaterial(Material.PolyGradientMaterial_Type, {
        fabric: {
            type: Material.PolyGradientMaterial_Type,
            uniforms: {
                color: color,
                alphaPower: 1.5,
                diffusePower: 1.6,
                globalAlpha:1,
                isInner: false,
                center: center
            },
            source: PolyGradientMaterial_Type
        },
        translucent: function translucent(material) {
            return true;
        }
    })
    Cesium.PolyGradientMaterialProperty = PolyGradientMaterialProperty;
}


//扫描圆
import RadarWaveMaterial_Type from './RadarWaveMaterial.js'
import RadarWaveMaterialProperty from '../MaterialProperty/RadarWaveMaterialProperty.js'
function registerRadarWaveMaterial(Material) {
    Material.RadarWaveMaterial_Type = FingerPrint + "RadarWaveMaterial_Type";
    Cesium.Material._materialCache.addMaterial(Material.RadarWaveMaterial_Type, {
        fabric: {
            type: Material.RadarWaveMaterial_Type,
            uniforms: {
                color: Cesium.Color.RED.withAlpha(0.2),
                speed: 10.0,
            },
            source: RadarWaveMaterial_Type
        },
        translucent: function translucent(material) {
            return true;
        }
    })
    Cesium.RadarWaveMaterialProperty = RadarWaveMaterialProperty;
}

//扫描圆(绿色/雄安)
import RadarWaveGreenMaterialProperty from '../MaterialProperty/RadarWaveGreenMaterialProperty.js'
function registerRadarWaveGreenMaterial(Material) {
    Material.RadarWaveGreenMaterial_Type = FingerPrint + "RadarWaveGreenMaterial_Type";
    Cesium.Material._materialCache.addMaterial(Material.RadarWaveGreenMaterial_Type, {
        fabric: {
            type: Material.RadarWaveGreenMaterial_Type,
            uniforms: {
                color: Cesium.Color.GREEN.withAlpha(0.2),
                speed: 10.0,
            },
            source: RadarWaveMaterial_Type
        },
        translucent: function translucent(material) {
            return true;
        }
    })
    Cesium.RadarWaveGreenMaterialProperty = RadarWaveGreenMaterialProperty;
}

export default function registerAll(Material) {
    registerDynamicWallMaterial(Material);
    registerStandardWallMaterial(Material);
    registerPolylineTrailLinkMaterial(Material);
    registerLineFlowMaterial(Material);
    registerDiffusionCircleMaterial(Material);
    registerDynamicCircleAMaterial(Material);
    registerDynamicCircleBMaterial(Material);
    registerRadarRadiationWaveMaterial(Material);
    registerDynamicWaterMaterial(Material);
    registerElectricArcMaterialMaterial(Material);
    registerSatelliteMaterial(Material);
    registerPolyGradientMaterial(Material);
    registerRadarWaveMaterial(Material);
    registerRadarWaveGreenMaterial(Material);
}